<pia3-speaker-selector
[clientID]="clientID"
[selectorMode]="selectorMode"
(speakerSelected)="_speakerSelected($event)"
></pia3-speaker-selector>